import React, { useContext } from 'react';

import './OnlineStoreLink.scss';
import { LanguageContext } from '../../../context/language-context';

const OnlineStoreLink = ({ className }) => {
  const lng = useContext(LanguageContext);
  const { language } = lng;

  return (
    <ul className={`online-store-link ${className}`}>
      <li className="online-store-link__item" data-icon="flight">
        <a
          href="https://kentotakeuchi.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {language === 'en' ? 'shop' : 'ショップ'}
        </a>
      </li>
      <li className="online-store-link__item" data-icon="local_shipping">
        <a
          href="https://kentotakeuchi.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {language === 'en' ? 'deli/pickup' : '配達/ピックアップ'}
        </a>
      </li>
    </ul>
  );
};

export default OnlineStoreLink;
